import ModalDeleteFilled from '../../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteBuyInvoiceDraftProps extends ModalEditComponentProps { }

const ModalDeleteBuyInvoiceDraft: React.FC<ModalDeleteBuyInvoiceDraftProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/buy/buyInvoice/deleteBuyInvoiceDraft',
        data: {
            id: allRowData?.header?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteDraftBuyInvoice', '¿Seguro que quieres eliminar este borrador de factura?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteBuyInvoiceDraft